// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3f_Ex","box":"WorkspacesBox_box__3ZlP8","node":"WorkspacesBox_node__cDMtR"};